import { Injectable } from '@angular/core';
 

@Injectable() 

export class Globals {
    //api_url = 'http://192.168.4.200:8080/dmcs/backend/';    
    //api_url = 'http://localhost/col/backend/';  
     api_url = 'http://192.168.56.1/col/backend/';
} 


// WEBPACK FOOTER //
// ./src/app/_Globals/globals.ts